/* eslint-disable jira/filename-case */
import { Component } from 'react';
import isEqual from 'lodash/isEqual';
import type { Match, Route } from '@atlassian/react-resource-router';
import { calcRapidBoardResetState } from '../../utils/index.tsx';

type TriggerProps = {
	// eslint-disable-next-line jira/react/handler-naming
	resetCurrentPage: () => void;
	match: Match;
	route: Pick<Route, 'name'>;
};

// oxlint-disable-next-line react/prefer-function-component
export default class CustomTrigger extends Component<TriggerProps> {
	constructor(props: TriggerProps) {
		super(props);
		const [paths] = calcRapidBoardResetState(
			this.rapidBoardPaths,
			this.props.route.name,
			!!this.props.match.query.useStoredSettings,
		);
		this.rapidBoardPaths = paths;
	}

	shouldComponentUpdate(nextProps: TriggerProps): boolean {
		if (!isEqual(this.props.match, nextProps.match)) {
			// RapidboardPaths is being persisted here.
			// resetDone boolean is calculated in the util function.
			const [paths, resetBoolean] = calcRapidBoardResetState(
				this.rapidBoardPaths,
				nextProps.route.name,
				!!nextProps.match.query.useStoredSettings,
			);
			this.rapidBoardPaths = paths;
			this.resetDone = resetBoolean;
		}
		return true;
	}

	componentDidUpdate(): void {
		if (!this.resetDone) {
			if (!__SPA__) {
				this.resetDone = true;
				return;
			}
			this.props.resetCurrentPage();
			this.resetDone = true;
		}
	}

	resetDone = true;

	rapidBoardPaths: string[] = [];

	render(): null {
		return null;
	}
}
